import { buildModelManager } from "../builder.js";
const DefaultEmsRunEvaluationSelection = {
  __typename: true,
  id: true,
  canonicalEncounter: true,
  createdAt: true,
  createdById: true,
  evaluationResult: true,
  findingsSummary: { markdown: true, truncatedHTML: true },
  groundTruthMetadata: true,
  institution: true,
  originalFileId: true,
  profileSources: true,
  rulePackVersions: true,
  scopeSummary: true,
  scores: true,
  sourcePayload: true,
  sourceReference: true,
  sourceSystem: true,
  sourceType: true,
  status: true,
  title: true,
  updatedAt: true
};
const modelApiIdentifier = "emsRunEvaluation";
const pluralModelApiIdentifier = "emsRunEvaluations";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEmsRunEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultEmsRunEvaluationSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmsRunEvaluationSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmsRunEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultEmsRunEvaluationSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEmsRunEvaluationSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultEmsRunEvaluationSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createEmsRunEvaluation",
    operationReturnType: "CreateEmsRunEvaluation",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      emsRunEvaluation: { required: false, type: "CreateEmsRunEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmsRunEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkCreateEmsRunEvaluations",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateEmsRunEvaluationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultEmsRunEvaluationSelection
  },
  {
    type: "action",
    operationName: "updateEmsRunEvaluation",
    operationReturnType: "UpdateEmsRunEvaluation",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      emsRunEvaluation: { required: false, type: "UpdateEmsRunEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmsRunEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateEmsRunEvaluations",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateEmsRunEvaluationsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultEmsRunEvaluationSelection
  },
  {
    type: "action",
    operationName: "deleteEmsRunEvaluation",
    operationReturnType: "DeleteEmsRunEvaluation",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteEmsRunEvaluations",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertEmsRunEvaluation",
    operationReturnType: "UpsertEmsRunEvaluation",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      emsRunEvaluation: { required: false, type: "UpsertEmsRunEvaluationInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateEmsRunEvaluationResult": { hasReturnType: false },
      "... on UpdateEmsRunEvaluationResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultEmsRunEvaluationSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertEmsRunEvaluations",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertEmsRunEvaluationsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultEmsRunEvaluationSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "emsRunEvaluationGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const EmsRunEvaluationManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultEmsRunEvaluationSelection,
  operations
);
export {
  DefaultEmsRunEvaluationSelection,
  EmsRunEvaluationManager
};
//# sourceMappingURL=EmsRunEvaluation.js.map
